import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { DECIMALS_SHOW } from 'structure/bridge/constants/constants';
import { bridgeAtom } from 'structure/bridge/store/bridgeAtom';
import { firstDecimals } from 'structure/bridge/utils/bridgeStateHelpers';
import { formatUnits } from 'viem';
import { Input } from 'baseui/input';
import { LabelSmall } from 'baseui/typography';
import { cx } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';
import styles from '../bridge.module.css';
import Image from 'next/image';
import { useMemo } from 'react';

export function BridgeDestinationAndAmount() {
  const { t } = useTranslation('common');
  const [bridgeState] = useAtom(bridgeAtom);

  const value = useMemo(() => {
    if (bridgeState.tokenQuoteLoading) return 'Loading...';
    else {
      return firstDecimals(
        bridgeState.amount -
          parseFloat(
            formatUnits(
              BigInt(bridgeState.tokenFee.toString()),
              bridgeState.token?.decimals
            )
          ),
        DECIMALS_SHOW
      ).toString();
    }
  }, [
    bridgeState.amount,
    bridgeState.tokenFee,
    bridgeState.token,
    bridgeState.tokenQuoteLoading,
  ]);

  return (
    <div className=' rounded-none pt-8'>
      <LabelSmall
        className={cx(twMerge(styles.label, 'mb-2 text-white-600'))}
        font={'14px'}
      >
        {t('AMOUNT')}
      </LabelSmall>
      <Input
        disabled={true}
        value={value}
        autoFocus
        overrides={{
          StartEnhancer: {
            style: (_) => {
              return {
                backgroundColor: 'transparent',
                minWidth: '10rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'start',
                paddingLeft: '0',
                paddingRight: '0',
                paddingTop: '16px',
                paddingBottom: '16px',
              };
            },
          },
          Input: {
            style: (_) => {
              return {
                backgroundColor: '#000000',
                fontFamily: 'Montserrat',
                textAlign: 'right',
              };
            },
          },
          Root: {
            style: (_) => {
              return {
                backgroundColor: '#000000',
                fontFamily: 'Montserrat',
                borderTopLeftRadius: '0px',
                borderTopRightRadius: '0px',
                borderBottomLeftRadius: '0px',
                borderBottomRightRadius: '0px',
                borderLeftWidth: '0.25px',
                borderRightWidth: '0.25px',
                borderTopWidth: '0.25px',
                borderBottomWidth: '0.25px',
                borderLeftStyle: 'solid',
                borderBottomStyle: 'solid',
                borderRightStyle: 'solid',
                borderTopStyle: 'solid',
                borderTopLeftColor: '#B5B5B5',
                borderBottomLeftColor: '#B5B5B5',
                borderTopRightColor: '#B5B5B5',
                borderBottomRightColor: '#B5B5B5',
              };
            },
          },
        }}
        startEnhancer={
          <div className='flex cursor-not-allowed flex-row items-center gap-2'>
            <Image
              src={bridgeState.token.imageUrl ?? ''}
              className='rounded-full'
              alt='TokenIcon'
              width={24}
              height={24}
            />
            <LabelSmall
              className={cx(twMerge(styles.bridgeFont, 'text-lg uppercase'))}
            >
              {bridgeState.token.symbol}
            </LabelSmall>
          </div>
        }
        placeholder={`${t('AMOUNT')} ${bridgeState.token?.symbol}`}
        clearOnEscape
      />
    </div>
  );
}
